'use client'
import 'remixicon/fonts/remixicon.css';
import '../../public/css/navbar.css';
import '../../public/fonts/flaticon_mycollection.css';
import 'swiper/css/bundle';
import "./globals.css";

import BackToTop from '../components/UverceeComponents/Layout/BackToTop';
import TosterProvider from '@/providers/TosterProvider';
import { Inter } from "next/font/google";
import Popup from "../components/UverceeComponents/PopUp/Popup";

// --- Google Tag Manager ID ---
const GTM_ID = "GTM-TCLTMDSH"; // Replace with your own GTM container ID

const inter = Inter({
  weight: ["200", "300", "400", "500", "600", "700", "800"],
  subsets: ["latin"],
  display: "swap",
});

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang="en">
       {/* <script src="//code.tidio.co/jokpnsyr6qoxgi9njco4ozkzybicdmze.js" async></script> */}
      <head>
        {/* Favicon */}
        <link rel="icon" href="/images/favicon.ico" />

        {/* Google Tag Manager Script */}
        {/* This will appear in the <head> of every page. */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];
              w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
              var f=d.getElementsByTagName(s)[0],
                  j=d.createElement(s),
                  dl=l!='dataLayer'?'&l='+l:'';
              j.async=true; j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
              f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${GTM_ID}');
            `,
          }}
        />
      </head>
      <body className={inter.className}>
        {/* Google Tag Manager (noscript) */}
        <noscript
          dangerouslySetInnerHTML={{
            __html: `
              <iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}"
                height="0" width="0" style="display:none;visibility:hidden">
              </iframe>
            `,
          }}
        />

        {children}
        <BackToTop />
        <Popup/>
      </body>
    </html>
  );
}
